import { Clock, Ban, UserX, Luggage, AlertTriangle, UserMinus, Heart } from 'lucide-react';
import { Reveal } from './motion/Reveal';
import { StaggerGroup, StaggerItem } from './motion/Stagger';

export const ProblemTypes = () => {
  const problems = [
    { icon: Ban, title: 'Voo cancelado', description: 'Seu voo foi cancelado sem aviso? Você tem direito a indenização.' },
    { icon: Clock, title: 'Voo atrasado', description: 'Esperou mais de 4 horas? A companhia deve te compensar.' },
    { icon: UserX, title: 'Overbooking', description: 'Não deixaram você embarcar? Isso é ilegal e tem solução.' },
    { icon: UserMinus, title: 'No-Show', description: 'Perdeu a volta por não usar a ida? Podemos ajudar.' },
    { icon: AlertTriangle, title: 'Conexão perdida', description: 'Perdeu o voo de conexão? A culpa pode ser da companhia.' },
    { icon: Luggage, title: 'Extravio de bagagem', description: 'Sua mala sumiu ou chegou danificada? Resolva agora.' },
  ];

  return (
    <section
      id="problemas"
      data-testid="problem-types-section"
      className="py-20 bg-slate-50"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <Reveal delay={0.1} className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-blue-600 text-sm font-semibold mb-4">
            <Heart className="w-4 h-4" />
            <span>Você não está sozinho</span>
          </div>
          <h2
            data-testid="problem-types-title"
            className="text-3xl md:text-4xl font-bold text-slate-900 mb-4"
          >
            Passou por algum desses problemas?
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            A gente entende como é frustrante. Por isso, estamos aqui pra
            transformar seu problema em solução — de forma simples e sem complicação.
          </p>
        </Reveal>

        {/* Problems Grid */}
        <StaggerGroup staggerDelay={0.1} startDelay={0.2} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {problems.map((problem, index) => (
            <StaggerItem
              key={index}
              data-testid={`problem-card-${index}`}
              whileHover={{ y: -8 }}
              whileTap={{ scale: 0.98 }}
              className="group bg-white p-6 rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_-15px_rgba(37,99,235,0.25)] hover:border-blue-200 transition-shadow duration-500 cursor-pointer"
            >
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-4 group-hover:bg-blue-100 transition-colors">
                <problem.icon className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-blue-600 transition-colors">
                {problem.title}
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed">
                {problem.description}
              </p>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
